import { NavigationConfig } from '@client-monorepo/wealth/navigation';

export const environment = {
  env: 'production',
  app_url: 'https://app.mydigipay.com/',
  base_url: 'https://api.mydigipay.com/digipay/api',
  base_url_origin: 'https://api.mydigipay.com',
  base_url_abs: 'https://api.mydigipay.com/digipay/api',
  base_url_origin_abs: 'https://api.mydigipay.com',
  agents: {
    web_agent: 'WEB',
    android_agent: 'HYBRID_ANDROID',
    ios_agent: 'HYBRID_IOS',
  },
  client_ids: {
    web_username: 'webapp-client-id',
    android_hybrid_username: 'hybrid-android-client-id',
    ios_hybrid_username: 'hybrid-ios-client-id',
  },
  client_secrets: {
    web_password: 'webapp-client-secret-debee79d-b04d-47ef-8ed5-c32e24ec836e',
    android_hybrid_password: 'hybrid-android-client-secert-ddd6c372-c3a0-4964-8faa-7b57d76f573b',
    ios_hybrid_password: 'hybrid-ios-client-secert-88b40c21-6c9b-42e9-8191-1d1a22664f44',
  },
  intrack_config: {
    app_key: 'AAAAeQ',
    auth_key: '37d18dc1-4f9a-4c90-af48-e599f288397e',
    public_key: 'BGo62NtHnoQ3p38ApWww7f6QNf_l3MQ0GiLdvo_87z2D6harVPceaCSwnJov77qnfgJPtqbixrUR3ql177Ga9gI=',
    android_auth_key: 'f8efcf8d-3a73-4987-8075-8894d09b87b9',
    ios_auth_key: '511ac095-f4a8-443f-8552-0e9553309261',
  },
  sentry_config: {
    dsn: 'https://80b563151f13470ab9bb0d8f0d0ed3ba@crashlytics.mydigipay.com/86',
    target: ['https://app.mydigipay.com'],
    tracesSampleRate: 0.01,
  },
  google_tag_manager_id: 'GTM-PS2XTV5J',
  digipay_version: '2025-01-01',
  version_check_period_seconds: '180',
  wealth: {
    navigation: {
      appName: 'dpx',
      isPrefix: true,
      prefix: 'mini-app/wealth',
    } as NavigationConfig,
  },
  bnpl_1pay_purchase_url: 'https://web.mydigipay.com/credit/bnpl-pay/details',
  mapKey: '2XfZItOluM7JHnmwX1tg',
  mapBaseUrl: 'https://tile.openstreetmap.org',
  appVersion: '3.1.5',
};
